'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.dashboard', {
    url: '/',
    resolve: {
      flow: function (auth, Api) {
        return Api.flow();
      },
      history: function (flow, Api, instance) {
        return Api.history(instance);
      }
    },
    templateUrl: '/app/states/dashboard/dashboard.html',
    controller: function ($scope, $state, $http, history, Api, HistoryAction, rmGuide) {
      var guideId = 'homeScreen';
      var guide =  _.find($scope.instance.guides, { id: guideId });
      var wasShownToUser = _.find($scope.user.meta.instance.guides, { id: guideId});
      $scope.introductionGuide = !wasShownToUser && (guide && guide.enabled) ? _.cloneDeep(guide) : false;
      $scope.showTutorial = !$scope.introductionGuide && _.get($scope.instance, 'tutorial.enabled', false);
      $scope.isTutorialViewed = function (id) {
        return rmGuide.isViewed(id);
      };
      $scope.onNotificationDismiss = function () {
        rmGuide.markViewed($scope.instance.tutorial.id);
      };
      $scope.onGuideExit = function () {
        return $http.post('/api/v1/me/guides/' + guideId).then(Api.me);
      };
      $scope.onGuideCompleted = function () {
        $scope.showTutorial = _.get($scope.instance, 'tutorial.enabled', false);
        $scope.onGuideExit().then(function () {
          $state.go('instance.app.module', {
            moduleId: _.first($scope.instance.modules)._id
          });
        });
      };
      Api.track('dashboard', 'view', {});
      $scope.history = history;
      $scope.history.recent.forEach(HistoryAction.format);

      $scope.graph = {
        labels: _.pluck(history.ranges, 'label'),
        series: [_.pluck(history.ranges, 'points')]
      };

      $scope.next = function (step) {
        if (step.name == 'module.introduction') {
          step.name = 'module';
        }
        $state.go('instance.app.' + step.name, step.params);
      };

      $scope.openDoc = function (doc) {
        $scope.$popup('pdf', { type: 'user', src: doc });
      };

    }
  });

});
